import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/core';
import { RESOURCE_CHANGES_REPOSITORY } from '../../core';

function getKey(resourceId) {
  return "AI_CHANGE_".concat(resourceId);
}

export var LocalStorageResourceChangesRepository = /*#__PURE__*/function () {
  function LocalStorageResourceChangesRepository() {
    _classCallCheck(this, LocalStorageResourceChangesRepository);
  }

  _createClass(LocalStorageResourceChangesRepository, [{
    key: "getByResourceId",
    value: function () {
      var _getByResourceId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resourceId) {
        var key, raw, parsed;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!false) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail('Only available in browser'));

              case 3:
                key = getKey(resourceId);
                raw = window.localStorage.getItem(key);

                if (!(raw == null)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.ok([]));

              case 7:
                parsed = JSON.parse(raw);
                return _context.abrupt("return", Result.ok(Array.isArray(parsed) ? parsed : []));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", Result.fail(_context.t0));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      function getByResourceId(_x) {
        return _getByResourceId.apply(this, arguments);
      }

      return getByResourceId;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resourceId, changes) {
        var key;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!false) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", Result.fail('Only available in browser'));

              case 3:
                key = getKey(resourceId);
                window.localStorage.setItem(key, JSON.stringify(changes));
                return _context2.abrupt("return", Result.ok());

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", Result.fail(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      function save(_x2, _x3) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resourceId, itemId) {
        var getResult, list, next, saveResult;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!false) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", Result.fail('Only available in browser'));

              case 2:
                _context3.next = 4;
                return this.getByResourceId(resourceId);

              case 4:
                getResult = _context3.sent;

                if (!getResult.isFailure) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", getResult);

              case 7:
                list = getResult.getValue();
                next = list.filter(function (r) {
                  return r.id !== itemId;
                });

                if (!(next.length === 0)) {
                  _context3.next = 12;
                  break;
                }

                window.localStorage.removeItem(getKey(resourceId));
                return _context3.abrupt("return", Result.ok([]));

              case 12:
                _context3.next = 14;
                return this.save(resourceId, next);

              case 14:
                saveResult = _context3.sent;

                if (!saveResult.isFailure) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt("return", Result.fail(saveResult.error));

              case 17:
                return _context3.abrupt("return", Result.ok(next));

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function remove(_x4, _x5) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }, {
    key: "removeAll",
    value: function () {
      var _removeAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resourceId) {
        var key;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!false) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", Result.fail('Only available in browser'));

              case 2:
                key = getKey(resourceId);
                window.localStorage.removeItem(key);
                return _context4.abrupt("return", Result.ok());

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function removeAll(_x6) {
        return _removeAll.apply(this, arguments);
      }

      return removeAll;
    }()
  }]);

  return LocalStorageResourceChangesRepository;
}();
export var resourceChangesRepositoryProvider = {
  provide: RESOURCE_CHANGES_REPOSITORY,
  useClass: LocalStorageResourceChangesRepository
};